export default function Environment() {
  const features = [
    {
      icon: 'ri-heart-3-line',
      title: 'Équipe qualifiée',
      description: 'Éducatrices expérimentées et passionnées par le développement de l\'enfant'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Environnement sécuritaire',
      description: 'Espaces sécurisés et adaptés aux besoins de chaque groupe d\'âge'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Espaces stimulants',
      description: 'Aménagements conçus pour encourager l\'exploration et la curiosité'
    },
    {
      icon: 'ri-sun-line',
      title: 'Cadre lumineux',
      description: 'Environnement propre, lumineux et adapté au bien-être des enfants'
    }
  ];

  return (
    <section id="environnement" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-heart-line text-white text-2xl"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Un environnement bienveillant et sécuritaire
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Notre équipe éducative qualifiée veille à ce que chaque enfant se sente écouté, compris et valorisé. Les espaces sont aménagés pour encourager l'exploration et la curiosité, dans un cadre lumineux, propre et adapté aux besoins de chaque âge.
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-green-400 to-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-2">{feature.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/1dc8f14ebeb72f40b8d5992d1c28d440.jpg"
                alt="Environnement bienveillant"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-star-line text-white text-2xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
